import {ProductModel} from '../../api/product-model';

export class ProductViewModel {
  constructor(public product: ProductModel) {
    this.calc = product.calc;
    this.name = product.name;
    this.pType = product.pType;
    this.size = product.size;
    this.state = product.state === 'A';
    this.isCanister = product.isCanister;
    this.baseValidated = product.baseValidated;
    this.baseImageUrl = product.baseImageUrl;
    this.baseUniqueCode = product.baseUniqueCode;
  }

  calc: string;
  name: string;
  pType: string;
  size: number;
  state: boolean;
  isCanister: boolean;
  baseValidated: boolean;
  baseImageUrl: string;
  baseUniqueCode: string;
}
